import { Pipe, PipeTransform } from '@angular/core';
import { DropDownOption } from 'src/app/product-capture/model/interfaces/drop-down-option.interface';

@Pipe({
  name: 'selectLabel',
})
export class SelectLabelPipe implements PipeTransform {
  // Specific to underlying assets label (appears differently from dispalayValue)
  transform(item: DropDownOption, splitLabel?: boolean): string {
    const { displayValue: label } = item;

    if (splitLabel === false) {
      return label;
    }

    const cleanLabel = label?.split(' | ') || [];
    const splitPipeLabel = cleanLabel?.length ? cleanLabel[1] : label;
    const splitBrLabel = splitPipeLabel?.split('<br>');
    return splitBrLabel?.length ? splitBrLabel[0] : label;
  }
}
